import { EdgeListEligibleMembersRepository } from '@/modules/connect/infra'
import type { ListEligibleMembers } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeListEligibleMembers(): ListEligibleMembers {
  return new EdgeListEligibleMembersRepository(makeSupabaseEdgeHttpClient()).execute
}
